import React from 'react';
import ErrorIcon from '@assets/svg/error-icon.svg';
import ErrorAlertStyles from './ErrorAlert.module.scss';

type Props = {
  message: string;
};
export const ErrorAlert: React.FC<Props> = ({ message }) => {
  return (
    <div className={ErrorAlertStyles.error_alert}>
      <span className={ErrorAlertStyles.error_alert__icon}>
        <img src={ErrorIcon} alt="error" />
      </span>
      <p className={ErrorAlertStyles.error_alert__message}>{message}</p>
    </div>
  );
};
